import { lazy } from "react";
import { createBrowserRouter } from "react-router";
import { appRoutes } from "./routeConfig";

const AppRoot = lazy(() => import("./pages/AppRoot"));

export { appRoutes } from "./routeConfig";

export const router = createBrowserRouter([
  {
    Component: AppRoot,
    children: appRoutes,
  },
]);
